import { BusinessRuleType, EntityDefinition } from '../types/entity-definition.interface';
import { MeasureFormula } from '../types/measure-formula.interface';

export const measureFormulaDefinition: EntityDefinition<MeasureFormula> = {
  entityType: 'MeasureFormula',
  i18nBase: 'entities.measureFormula',
  list: {
    columns: [
      { field: 'startTs', headerKey: 'entities.measureFormula.fields.startTs', sortable: true, template: 'date' },
      { field: 'endTs', headerKey: 'entities.measureFormula.fields.endTs', sortable: true, template: 'date' },
    ],
  },
  validationRules: [
    {
      // Suspension segments always report hasValues=false server-side, so this rule
      // only ever blocks formula segments — suspensions stay freely deletable.
      type: BusinessRuleType.DELETE_VALIDATION,
      rule: (entity: MeasureFormula) => !entity.hasValues,
      errorMessageKey: 'entities.measureFormula.messages.deleteBlockedHasValuesHint',
    },
  ],
  actionButtons: {
    parent: {
      add: true,
      edit: true,
    },
  },
  messages: {
    dialogTitles: {
      create: () => 'entities.measureFormula.messages.createTitle',
      edit: () => 'entities.measureFormula.messages.editTitleWithName',
      delete: () => 'entities.measureFormula.messages.deleteTitleWithName',
    },
    buttons: {
      add: () => 'entities.measureFormula.messages.addButton',
      create: () => 'entities.measureFormula.messages.addButton',
      edit: () => 'entities.measureFormula.messages.editTitleWithName',
      delete: () => 'entities.measureFormula.messages.deleteTitle',
    },
    confirmDelete: () => 'entities.measureFormula.messages.deleteConfirm',
  },
};
